export default __webpack_public_path__ + "graphics/logo-with-lines.653f8316.svg";